import { useTranslation } from 'react-i18next';
import {
    Select,
    SelectContent,
    SelectItem,
    SelectTrigger,
    SelectValue,
} from '../ui/select';
import { FolderSort } from '../../services/api/folderService';

interface SortSelectProps {
    value: FolderSort;
    onChange: (sort: FolderSort) => void;
}

const SORT_LABEL_KEYS: Record<FolderSort, string> = {
    recent: 'folders.overview.sort.recent',
    newest: 'folders.overview.sort.newest',
    oldest: 'folders.overview.sort.oldest',
    'name-asc': 'folders.overview.sort.nameAsc',
    'name-desc': 'folders.overview.sort.nameDesc',
};

const SORT_OPTIONS = Object.keys(SORT_LABEL_KEYS) as FolderSort[];

export const SortSelect = ({ value, onChange }: SortSelectProps) => {
    const { t } = useTranslation();
    return (
        <Select
            value={value}
            onValueChange={(v) => onChange(v as FolderSort)}
        >
            <SelectTrigger className="h-8 w-36 text-xs">
                <SelectValue />
            </SelectTrigger>
            <SelectContent>
                {SORT_OPTIONS.map((key) => (
                    <SelectItem key={key} value={key}>
                        {t(SORT_LABEL_KEYS[key])}
                    </SelectItem>
                ))}
            </SelectContent>
        </Select>
    );
};
